module.exports = __webpack_public_path__ + "images/marketing/group-shot2.jpg";